import { useState, useEffect } from 'react';

const isLocalizationFromKeycloak = (value: string) =>
  typeof value === 'object' &&
  Array.isArray(value) === false &&
  Object.keys(value).length === 1 &&
  value['locale'] != null;

// ==============================|| HOOKS ||============================== //

export default function useLocalStorage<ValueType>(
  key: string,
  defaultValue: ValueType
) {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue == null) {
      return defaultValue;
    }

    const parsedValue = JSON.parse(storedValue);
    if (isLocalizationFromKeycloak(parsedValue)) {
      return { ...defaultValue, ...parsedValue };
    }
    return parsedValue;
  });

  useEffect(() => {
    const listener = (e: StorageEvent) => {
      if (e.storageArea === localStorage && e.key === key) {
        setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue);
      }
    };
    window.addEventListener('storage', listener);

    return () => {
      window.removeEventListener('storage', listener);
    };
  }, [key, defaultValue]);

  const setValueInLocalStorage = (newValue: ValueType) => {
    if (JSON.stringify(value) === JSON.stringify(newValue)) return;
    setValue((currentValue: any) => {
      const result =
        typeof newValue === 'function' ? newValue(currentValue) : newValue;
      localStorage.setItem(key, JSON.stringify(result));
      return result;
    });
  };

  return [value, setValueInLocalStorage];
}
